export type EntitlementTier = 'free' | 'pro';

export type EntitlementSource =
  | 'stripe'
  | 'appstore'
  | 'play'
  | 'microsoft'
  | 'legacy'
  | 'debug'
  | 'cache';

export interface EntitlementStatus {
  tier: EntitlementTier;
  source: EntitlementSource;
  expiresAt?: string;
  cachedUntil?: string;
  formattedPrice?: string;
}

export const PRODUCT_ID = 'pouches_pro_monthly';

/** iOS StoreKit metadata (offer/price) failed to load before purchase. */
export const APP_STORE_PRODUCT_NOT_LOADED = 'APP_STORE_PRODUCT_NOT_LOADED';

export const OFFLINE_CACHE_DAYS = 7;
